// extracted by mini-css-extract-plugin
export default {"root":"FullscreenButton_root__djCc9"};